import MenuViewMode from './MenuViewMode';
/*
import PhysicalCameraManager from '../../PhysicalCameraManager';
import MenuCameraManager from '../../MenuCameraManager';
import GeofenceManager from '../../GeofenceManager';
import TaglockMarkerManager from '../../TaglockMarkerManager';
import CameraObjectManager from '../../CameraObjectManager';
*/
/**
 * @class ArchiveMode
 * @description User is able to see his archive recorded files.Get activated when archive tab is clicked.
 * @function on_tab_selected() - Get called when user has clicked the tab. (called by MenuView).
 * @function on_player_hide() -  Get called when we want to hide the player. (called by PlayerContainer)
 * @function is_valid_camera() -  It works as filter for whcich camera to display in the menu view.Called by menuView.js
 * 
 */

// This represents the Archive mode of the MenuView
export default class ArchiveMode extends MenuViewMode
{
  constructor()
  {
    super('archive');
  }

  on_tab_selected(menu_view)
  {
    if (PhysicalCameraManager.selected_camera) PhysicalCameraManager.selected_camera.show_player_on_zoom = false;
    menu_view.fill_menu(0);
    GeofenceManager.hide_geofence();
    TaglockMarkerManager.remove_all_markers();

    CameraObjectManager.set_archive_mode();
  }

  is_valid_camera(physical_camera)
  {
    return (physical_camera.cam_type !== 'phone');
  }

  on_player_hide(player_container)
  {
    player_container.app.archive_telemetry_controller.stop_streaming(PhysicalCameraManager.selected_camera);
  }

  on_camera_selected(menu_view)
  {
    menu_view.show_calendar_view();

    if (app.local_file_storage)
    {
      menu_view.app.calendar_view.get_recordings_from_local(PhysicalCameraManager.selected_camera);
    }
    else
    {
      menu_view.app.calendar_view.get_recordings_from_server(PhysicalCameraManager.selected_camera);
    }

    app.local_file_manager.on_camera_selected();
  }

  on_day_selected(app)
  {
    app.player_view.extract_recording_view.hide_open_button();

    app.menu_view.show_recordings_list_view();

    PhysicalCameraManager.selected_camera.fly_on_valid_telemetry = true;

    app.local_file_manager.on_calendar_day_change();
  }

  on_recording_played(player_view, fragment)
  {
    player_view.app.archive_telemetry_controller.stop_streaming(PhysicalCameraManager.selected_camera);

    player_view.app.player_container.show_loading();

    setTimeout(function()
    {
      player_view.extract_recording_view.start_streaming(
        player_view.play.bind(player_view),
        fragment.get_relative_offset_ms(player_view.playback_time) / 1000,
        player_view.html_video,
        fragment.recording.encodedurl
      );
    }, 200);
  }
}
